"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkProcessWeaponCommand = exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageWeaponCommand_1 = require("@voyage/multi/voyageMessageWeaponCommand");
var voyageMessageWeaponCommand_sidecar_1 = require("@voyage/multi/voyageMessageWeaponCommand-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 3;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        status_1.addPower -= 10;
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
            assert_sidecar_1.assert.notNil(tHere);
            assert_sidecar_1.assert.notNil(tHere.system);
            voyageMessageWeaponCommand_sidecar_1.voyageMessageWeaponCommand.sendMessageAndImmediatelyExecute({
                command: voyageMessageWeaponCommand_1.EWeaponCommand.Fire,
                systemId: tHere.system.id,
                crewId: obj.id,
            });
        }
    }
}
exports.crewUpdate = crewUpdate;
function networkProcessWeaponCommand(msg, obj, t, sys) {
    if (msg.command === voyageMessageWeaponCommand_1.EWeaponCommand.Fire) {
        diveCrew_sidecar_1.diveCrew.say(obj, 'Firing!');
        voyageSounds_sidecar_1.voyageSounds.playFireLaser();
        voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.hurt(10);
        var fp = obj;
        var firePointSys = voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe('fp-' + t.text3);
        if (firePointSys) {
            fp = firePointSys;
        }
        voyageParticles_sidecar_1.voyageParticles.createMultiple('laser', voyageTilemap_sidecar_1.voyageTilemap.convertItoX(fp.i), voyageTilemap_sidecar_1.voyageTilemap.convertJtoY(fp.j), 1);
    }
    if (msg.command === voyageMessageWeaponCommand_1.EWeaponCommand.Load) {
    }
}
exports.networkProcessWeaponCommand = networkProcessWeaponCommand;
